module.exports = __webpack_public_path__ + "img/tool_inactive.a27c2083.svg";